<template>
	<div class="car-item text-center">

		<img
		:width="width"
		:src="(carGroup.download ? carGroup.download : '/static/img/car-dummy.png')">

		<div class="car-details">
<!-- 			<router-link :to="{name: 'PageDetails'}">
				<button type="button" class="btn btn-outline-info btn-wp">
					{{ $t('Details') }}
				</button>
			</router-link> -->
		</div>

		<p class="car-class">{{ carGroup.category}}</p>
		<h4 class="car-typ">{{ carGroup.app_description || carGroup.title_web }}</h4>

		<div v-if="price > 0">
			<button v-if="groupAvaible" @click="$emit('click', carGroup)" type="button" class="btn btn-secondary btn-wp">
				{{ $t('Select') }}
			</button>
			<br v-if="!groupAvaible" />
			<small  v-if="!groupAvaible" class="car-additional car-additional--error">Im gewählten Zeitraum nicht verfügbar</small> 
			<p class="car-price">{{ formatter.OUTPUT_PRICE(price) }} €</p>
		</div>
		<div v-else>{{ $t('Not available') }}</div>
	</div>
</template>

<script>
import formatter from '@/store/orm/helpers/formater';

export default {
	name: "CarCard",
	data() {
		return {
			formatter,
		};
	},
	props: {
		width: {
			type: Number,
			default: 320
		},
		price: {
			type: Number,
			default: 0
		},
		carGroup: {
			type: Object,
			default() {
				return {};
			}
		},
		groupAvaible: {
			type: Object,
			default() {
				return {};
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Generals/CarCard.vue